import { createImageCarousel } from '.';
import { queryAll, query } from '~/lib/utils/dom';
queryAll('.js-image-carousel-container')
    .map((main) => ({
    main,
    modal: {
        main: query('.js-image-carousel-modal', main),
        image: query('.js-image-carousel-modal-image', main),
        closeBtn: query('.js-image-carousel-modal-close-btn', main),
    },
    carousel: {
        main: query('.js-image-carousel-carousel-container', main),
        swiper: query('.js-image-carousel', main),
        prevBtn: query('.js-image-carousel-prev-btn', main),
        nextBtn: query('.js-image-carousel-next-btn', main),
    },
}))
    .map(createImageCarousel);
